import styled from 'styled-components';
import {
  Tag,
} from 'antd';

export const StyledAntdTag = styled(Tag)`
`;
